import React from 'react';
import './CaseStepperSimple.scss';

const CaseStepperSimple = (props) => {
  const totalSteps = props.layout.length;
  const percent = (100 / totalSteps) * (props.current + 1);
  const text = `${props.current + 1} di ${totalSteps}`

  return (
    <div className="CaseStepperSimple" data-testid="CaseStepperSimple">
      <div className="container details">
        <div className="row">
          <div className="col">
            <div className="text">{text}</div>
          </div>
          <div className="col">
            {props.link}
          </div>
        </div>
        <div className="bar"><div className="fill" style={{width: `${percent}%`}}>&nbsp;</div></div>
      </div>
    </div>
  )
};

export default CaseStepperSimple;
